module.exports = __webpack_public_path__ + "img/ellipses.f35eb20e.svg";